import React from 'react';
import { useLocation } from 'react-router-dom';
import Concents from '../components/business/Consents';
import ConsentsDetails from '../components/business/consents/ConsentsDetails';

export const ConcentsCtx = React.createContext({});

function ConcentsPageProvider(props) {
  const ctx = {
  };
  return (
    <ConcentsCtx.Provider value={ ctx }>
      {props.children}
    </ConcentsCtx.Provider>
  );
}

function ConcentsPage() {
  const location = useLocation();
  const { search } = location;
  const params = new URLSearchParams(search);
  const id = params.get('id');

  if (null != id) {
    return <ConsentsDetails id={ id } />;
  }

  return (
    <ConcentsPageProvider>
      <Concents />
    </ConcentsPageProvider>
  );
}

export default ConcentsPage;
